/**
 * 日程列表
 * created by lzy 2020.03.20
 */

'use strict';
angular.module('scheduleListModule', []).directive('scheduleList', ['trsHttpService', 'modalDialog', 'dateReminderService', 'messagePublishService', '$timeout', '$filter',
    function(trsHttpService, modalDialog, dateReminderService, messagePublishService, $timeout, $filter) {
        return {
            restrict: 'E',
            repalace: false,
            scope: {
                scheduleList: '=',
                userInfo: '=',
                type: '=',
                page: '=',
                selectDate: '@',
                callback: '&'
            },
            templateUrl: './dateReminder/directive/scheduleList/scheduleList.html',
            link: function($scope) {
                initStatus();
                initData();
                
                /**
                 * [initStatus description] 初始化状态
                 *
                 * @return  {[type]}  [return description]
                 */
                function initStatus() {
                    $scope.data = {
                        colors: {
                            1: '#f41d1d',
                            2: '#2481fc',
                            3: '#3cb76a'
                        },
                        taps: [{
                            name: '列表',
                            type: 'list'
                        }, {
                            name: '日',
                            type: 'day'
                        }],
                        selectedType: 'list',
                        yearArr: []
                    };
                    $scope.status = {};
                    $scope.rights = {};
                    // messagePublishService.subscribe('dayClick', function() {
                    //     $scope.data.
                    // }, $scope);
                }

                /**
                 * [initData description] 初始化数据
                 *
                 * @return  {[type]}   [return description]
                 */
                function initData() {
                    getNewsCalendarManagementRight();
                }

                /**
                 * [createNewSchedule description]新建和编辑日程
                 *
                 * @param   {[type]}  schedule  [schedule description]
                 *
                 * @return  {[type]}            [return description]
                 */
                $scope.createAndSaveSchedule = function(schedule) {
                    dateReminderService.createNewSchedule($scope.userInfo, schedule).then(function() {
                        messagePublishService.publish('createNewSchedule');
                        $scope.callback()();
                    });
                };

                /**
                 * [getNewsCalendarManagementRight description] 获取新闻日历管理权限，只有入口按钮总权限
                 *
                 * @return  {[type]}   [return description]
                 */
                function getNewsCalendarManagementRight() {
                    const params = {
                        serviceid: 'mlf_metadataright',
                        methodname: 'findMyOperRightByModal',
                        ModalName: 'iwo.calendar'
                    }
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                        for (var i = 0; i < data.length; i++) {
                            $scope.rights[data[i].OPERNAME] = data[i];
                        }
                    });
                }
                /**
                 * [pageChanged description] 换页
                 *
                 * @return  {[type]}  [return description]
                 */
                $scope.pageChanged = function() {
                    let params = {
                        pageNum: $scope.page.pageNum
                    };
                    $scope.callback()(params);
                };

                /**
                 * [changeTap description] 列表/日切换回调函数
                 *
                 * @return  {[type]}   [return description]
                 */
                $scope.changeTap = function() {
                    messagePublishService.publish('calendarTarget');
                    noDataStatus();
                }
                /**
                 * [deleteSchedule description] 删除日程
                 *
                 * @param   {[type]}  item  [item description]
                 *
                 * @return  {[type]}        [return description]
                 */
                $scope.deleteSchedule = function(item) {
                    modalDialog.confirmModal('删除', '确认删除该日程?', function () {
                        var params = {
                            serviceid: 'daily',
                            method: 'delete',
                            id: item.id
                        };
                        $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getMessageUrl(), params, 'post').then(function(data) {
                            modalDialog.alertType('', '删除日程成功', 'success', false);
                            messagePublishService.publish('createNewSchedule');
                            $scope.callback()();
                        });
                    });
                };

                /**
                 * [dropDownList description] 下拉框显示，当在最底部时向上展示
                 *
                 * @param  {[type]}  e   [e description] 
                 * @param  {[type]}  schedule   [schedule description]
                 *
                 * @return  {[type]}   [return description]
                 */
                $scope.dropDownList = function(e, schedule) {
                    var div = $(e.currentTarget).find('.dropdwon-list');
                    div.css({visibility: 'hidden'});
                    schedule.isShowDropdwonList=true;
                    $timeout(function() {
                        if (e.pageY + div.innerHeight() > $(window).height()) {
                            div.addClass('dropdwon-list-up');
                        }
                        div.css('visibility', 'visible');
                    })
                }

                /**
                 * [formatTime description] 整理时间，为任务和日程下的时间
                 *
                 * @param  {[type]}  item   [item description]
                 *
                 * @return  {[type]}[return description]
                 */
                $scope.formatTime = function(item) {
                    switch (item.type) {
                        case 1: 
                            item.showtime = item.starttime + ' 至 ' + item.endtime;
                            break;
                        case 2: 
                            item.showtime = item.thirdtime;
                            break;
                    }
                };

                /**
                 * [tiemFormat description] 月份聚合函数
                 *
                 * @param  {[type]}  key  [key description]
                 *
                 * @return  {[type]}   [return description]
                 */
                $scope.tiemFormat = function(key) {
                    var date = $filter('date')(key, 'yyyy年M月')
                    if ($scope.data.yearArr.indexOf(date) === -1) {
                        $scope.data.yearArr.push(date);
                    } else {
                        $scope.data.yearArr.push('');
                    }
                }

                /**
                 * 监听列表数据变化，为了让锚点起作用
                 */
                $scope.$watch('scheduleList', function() {
                    $scope.data.yearArr = [];
                    $scope.data.scheduleList = {};
                    $timeout(function() {
                        messagePublishService.publish('calendarTarget');
                        $scope.data.scheduleList = $scope.scheduleList;
                        noDataStatus();
                    })
                })

                /**
                 * 监听列表数据变化，为了让锚点起作用
                 */
                $scope.$watch('selectDate', function() {
                    noDataStatus();
                })

                function noDataStatus() {
                    $timeout(function() {
                        if ($scope.data.selectedType === 'list') {
                            if (JSON.stringify($scope.data.scheduleList) === '{}') {
                                $scope.status.noData = true;
                            } else {
                                $scope.status.noData = false;
                            }
                        } else {
                            if ($scope.data.scheduleList[$scope.selectDate]) {
                                $scope.status.noData = false;
                            } else {
                                $scope.status.noData = true;
    
                            }
                        }
                    })
                }
            }
        };
    }
]);
